import { render, staticRenderFns } from "./AppDetailPositionSync.vue?vue&type=template&id=d2ecb106&scoped=true";
import script from "./AppDetailPositionSync.vue?vue&type=script&lang=js";
export * from "./AppDetailPositionSync.vue?vue&type=script&lang=js";
import style0 from "./AppDetailPositionSync.vue?vue&type=style&index=0&id=d2ecb106&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "d2ecb106", null);
export default component.exports;